module.exports = "<svg id=\"SVGRoot\" version=\"1.1\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m2 2 28 15-28 13z\"></path></svg>"